// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rich-text-editor-wrapper {
  margin-bottom: 1rem;
}
.rich-text-editor-wrapper .form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}
.rich-text-editor-wrapper ::ng-deep .ql-toolbar {
  border-radius: 0.375rem 0.375rem 0 0;
  background-color: #f8f9fa;
}
.rich-text-editor-wrapper ::ng-deep .ql-container {
  border-radius: 0 0 0.375rem 0.375rem;
  font-size: 14px;
}
.rich-text-editor-wrapper ::ng-deep .ql-editor {
  min-height: 200px;
  font-family: Arial, sans-serif;
}
.rich-text-editor-wrapper ::ng-deep .ql-toolbar.ql-ltr {
  direction: ltr;
}
.rich-text-editor-wrapper ::ng-deep .ql-toolbar.ql-rtl {
  direction: rtl;
}
.rich-text-editor-wrapper ::ng-deep .ql-editor.ql-rtl {
  direction: rtl;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/rich-text-editor/rich-text-editor.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AACE;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;AACJ;AAEE;EACE,oCAAA;EACA,yBAAA;AAAJ;AAGE;EACE,oCAAA;EACA,eAAA;AADJ;AAIE;EACE,iBAAA;EACA,8BAAA;AAFJ;AAME;EACE,cAAA;AAJJ;AAOE;EACE,cAAA;AALJ;AAQE;EACE,cAAA;EACA,iBAAA;AANJ","sourcesContent":[".rich-text-editor-wrapper {\r\n  margin-bottom: 1rem;\r\n\r\n  .form-label {\r\n    font-weight: 500;\r\n    margin-bottom: 0.5rem;\r\n    display: block;\r\n  }\r\n\r\n  ::ng-deep .ql-toolbar {\r\n    border-radius: 0.375rem 0.375rem 0 0;\r\n    background-color: #f8f9fa;\r\n  }\r\n\r\n  ::ng-deep .ql-container {\r\n    border-radius: 0 0 0.375rem 0.375rem;\r\n    font-size: 14px;\r\n  }\r\n\r\n  ::ng-deep .ql-editor {\r\n    min-height: 200px;\r\n    font-family: Arial, sans-serif;\r\n  }\r\n\r\n  // RTL support\r\n  ::ng-deep .ql-toolbar.ql-ltr {\r\n    direction: ltr;\r\n  }\r\n\r\n  ::ng-deep .ql-toolbar.ql-rtl {\r\n    direction: rtl;\r\n  }\r\n\r\n  ::ng-deep .ql-editor.ql-rtl {\r\n    direction: rtl;\r\n    text-align: right;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
